<template>
    <div>
        <div v-if="is_show">
            <span style="margin-right:15px;">
                {{ now_ > end_time ? '本轮竞价倒计时' : '自由竞价倒计时' }} :
            </span>
            <span style="font-size:26px;">{{ countdown1.minutes }}</span>
            <span style="color:#999;font-size:16px;">分</span>
            <span style="font-size:26px;">{{ countdown1.seconds }}</span>
            <span style="color:#999;font-size:16px;">秒</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            now_offset: 0,     // 本地与服务器时间差
            now_: 0,           // 当前时间戳（ms）
            end_time: 0,       // 竞价结束时间戳（ms）
            countdown1: { minutes: 0, seconds: 0 },
            timer1: null,      // 本地倒计时定时器
            syncTimer: null,   // 同步服务器时间定时器
            is_show: true,
        };
    },
    props: {
        detail_data: { type: Object, default: () => ({}) },
        startTimestamp: { type: Number, required: true }, // 单轮或自由竞价起始时间（秒）
        endTimestamp: { type: Number, required: true },   // 上轮结束时间（秒）
    },
    mounted() {
        this.initSync();
    },
    beforeDestroy() {
        clearInterval(this.timer1);
        clearInterval(this.syncTimer);
    },
    methods: {
        // 初始同步一次，并启动本地倒计时和周期同步
        async initSync() {
            await this.syncServerTime();
            this.calculateTime();
            this.timer1 = setInterval(this.tick, 1000);
            this.syncTimer = setInterval(this.syncServerTime, 30000);
        },
        // 向后端请求时间并更新 now_offset
        async syncServerTime() {
            const before = Date.now();
            const res = await this.$http.post('/api/index/get_time');
            const after = Date.now();
            const serverTime = res.data.data.time * 1000;
            const latency = (after - before) / 2;
            this.now_offset = serverTime - after + latency;
        },
        // 获取与服务器同步的当前本地时间
        getNow() {
            return Date.now() + this.now_offset;
        },
        // 定时器每秒触发
        tick() {
            this.calculateTime();
        },
        // 倒计时主体逻辑
        calculateTime() {
            this.now_ = this.getNow();
            this.end_time = this.detail_data.BIDDING_END_TIME * 1000;

            let djs_minute = 0;
            if (this.detail_data.BIDDING_TYPE == 1) {
                djs_minute = this.detail_data.DURATION;
            } else {
                djs_minute = this.now_ > this.end_time
                    ? this.detail_data.ROUND_DELAY
                    : this.detail_data.DURATION;
            }

            const origin = this.startTimestamp * 1000;
            const target = origin + djs_minute * 60 * 1000;
            const diff = target - this.now_;

            if (diff <= 0) {
                this.countdown1 = { minutes: 0, seconds: 0 };
                this.$emit('handle_update_');
                this.is_show = false;
                clearInterval(this.timer1);
                clearInterval(this.syncTimer);
                return;
            }

            const totalSec = Math.floor(diff / 1000);
            this.countdown1 = {
                minutes: Math.floor(totalSec / 60),
                seconds: totalSec % 60,
            };
        },
    },
};
</script>